
import { cdn_URL } from "../config/config";

/**
 * Returns a CDN thumbnail URL for a given S3 image URL.
 * Uses Thumbor-style URL: 400px wide, WebP, quality 85.
 * Falls back to the original URL for non-S3 URLs or on error.
 */
export function getS3Thumb(url) {
  if (!url) return "";
  try {
    const key = url
      .replace(/^https?:\/\/[^/]+\.s3[^/]*\.amazonaws\.com\//, "")
      .replace(/^s3:\/\/[^/]+\//, "");
    if (key === url) return url; // not an S3 URL — return as-is
    return `${cdn_URL}/fit-in/400x0/filters:format(webp):quality(85)/${key}`;
  } catch {
    return url;
  }
}

export function deepClean(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map(deepClean)
      .filter(
        (item) =>
          item !== undefined &&
          item !== null &&
          !(typeof item === "string" && item.trim() === "") &&
          !(Array.isArray(item) && item.length === 0) &&
          !(typeof item === "object" && Object.keys(item).length === 0)
      );
  } else if (typeof obj === "object" && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleaned = deepClean(value);
      if (
        cleaned !== undefined &&
        cleaned !== null &&
        !(typeof cleaned === "string" && cleaned.trim() === "") &&
        !(Array.isArray(cleaned) && cleaned.length === 0) &&
        !(typeof cleaned === "object" && Object.keys(cleaned).length === 0)
      ) {
        acc[key] = cleaned;
      }
      return acc;
    }, {});
  }
  return obj;
}



export function getURLParams(filters) {
  if (!filters || Object.keys(filters).length === 0) return "";
  const cleaned = deepClean(filters);
  console.log("CLEANED FILTERS:", cleaned);
  if (Object.keys(cleaned).length === 0) return "";
  return `filters=${JSON.stringify(cleaned)}`;
}